/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type PreAddOrgTagsMutationInput = {
    clientMutationId?: string | null | undefined;
    moveRangeV3?: MoveRangeInLocalTimeV3Input | null | undefined;
    orgRelayId: string;
    preAnnotation: PreAnnotationInput;
};
export type MoveRangeInLocalTimeV3Input = {
    allowedEndTimeInclusive?: DayOffsetTimeSlotInput | null | undefined;
    allowedStartTimeInclusive?: DayOffsetTimeSlotInput | null | undefined;
};
export type DayOffsetTimeSlotInput = {
    dayOffset: number;
    timeSlot: TimeSlot;
};
export type PreAnnotationInput = {
    attendees: Array<string>;
    calendarId: string;
    description?: string | null | undefined;
    endTime: InferredEventTimeInput;
    startTime: InferredEventTimeInput;
    tags: Array<TagInput>;
    title?: string | null | undefined;
};
export type InferredEventTimeInput = {
    date: string;
    time: string;
    timeZone?: string | null | undefined;
};
export type TagInput = {
    name: string;
    value?: string | null | undefined;
};
export type PreAddOrgTagsMutationVariables = {
    input: PreAddOrgTagsMutationInput;
};
export type PreAddOrgTagsMutationResponse = {
    readonly preAddOrgTags: {
        readonly clientMutationId: string | null;
    } | null;
};
export type PreAddOrgTagsMutation = {
    readonly response: PreAddOrgTagsMutationResponse;
    readonly variables: PreAddOrgTagsMutationVariables;
};



/*
mutation PreAddOrgTagsMutation(
  $input: PreAddOrgTagsMutationInput!
) {
  preAddOrgTags(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "PreAddOrgTagsMutationPayload",
            "kind": "LinkedField",
            "name": "preAddOrgTags",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "PreAddOrgTagsMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "PreAddOrgTagsMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "901cdcf41787f58db56454dbfafaa42c",
            "id": null,
            "metadata": {},
            "name": "PreAddOrgTagsMutation",
            "operationKind": "mutation",
            "text": "mutation PreAddOrgTagsMutation(\n  $input: PreAddOrgTagsMutationInput!\n) {\n  preAddOrgTags(input: $input) {\n    clientMutationId\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'ff7f03cc1b2bddfa5d8412a0d7528eb1';
export default node;
